(() => {
  if (window.certificationEvidenceInitialized) return;
  window.certificationEvidenceInitialized = true;
  document.addEventListener('keydown', event => {
    const dialog = document.querySelector('.certification-lightbox[open]');
    if (event.key === 'Escape' && dialog) {
      event.preventDefault();
      event.stopImmediatePropagation();
      dialog.close();
    }
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-certification-image]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const dialog = link.closest('.safety-details')?.querySelector('.certification-lightbox');
    if (!dialog?.showModal) return;
    event.preventDefault();
    const previousImage = dialog.querySelector('img');
    const thumbnail = link.querySelector('img');
    const image = thumbnail ? thumbnail.cloneNode(false) : document.createElement('img');
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.className = previousImage.className;
    image.width = previousImage.width;
    image.height = previousImage.height;
    image.loading = 'eager';
    image.fetchPriority = 'high';
    image.alt = thumbnail?.alt || link.dataset.certificationTitle || '';
    previousImage.replaceWith(image);
    dialog.querySelector('.certification-lightbox__content').scrollTop = 0;
    if (image.src !== link.href) image.src = link.href;
    const previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      link.focus();
    }, { once: true });
  });
  document.addEventListener('click', event => {
    if (event.target.closest('.certification-lightbox__close')) {
      event.target.closest('dialog').close();
    } else if (event.target.matches('.certification-lightbox')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
})();
